import React from 'react';
import { TrendingDown, BadgeIndianRupee, TrendingUp, Leaf } from 'lucide-react';
import { mockBenefits } from '../mock';

const iconMap = {
  TrendingDown: TrendingDown,
  BadgeIndianRupee: BadgeIndianRupee,
  TrendingUp: TrendingUp,
  Leaf: Leaf
};

const Benefits = () => {
  return (
    <section id="benefits" className="py-20 bg-white">
      <div className="container mx-auto px-4 md:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Why Choose{' '}
            <span style={{background: 'linear-gradient(90deg, #2CC84B, #00BCD4)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text'}}>Solar Energy</span>?
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Experience the benefits of clean, renewable energy while saving money
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {mockBenefits.map((benefit) => {
            const IconComponent = iconMap[benefit.icon];
            return (
              <div
                key={benefit.id}
                className="text-center p-8 rounded-xl bg-gradient-to-b from-gray-50 to-white hover:shadow-lg transition-all duration-300 hover:-translate-y-2 hover:shadow-[0_0_20px_rgba(44,200,75,0.15)]"
              >
                <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg" style={{background: 'linear-gradient(135deg, #2CC84B, #00BCD4)'}}>
                  <IconComponent className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {benefit.title}
                </h3>
                <p className="text-gray-600">
                  {benefit.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Subsidy Highlight Banner */}
        <div className="mt-16 rounded-2xl p-8 md:p-12 text-white text-center" style={{background: 'linear-gradient(90deg, #2CC84B, #00BCD4)'}}>
          <h3 className="text-2xl md:text-3xl font-bold mb-4">
            Government Subsidy Available!
          </h3>
          <p className="text-lg md:text-xl mb-6 opacity-90">
            Get up to 40% subsidy on residential solar installations under PM Surya Ghar Scheme
          </p>
          <div className="flex flex-wrap justify-center gap-8 mt-8">
            <div>
              <p className="text-4xl font-bold">₹30,000</p>
              <p className="text-sm opacity-80">Subsidy for 1kW</p>
            </div>
            <div>
              <p className="text-4xl font-bold">₹60,000</p>
              <p className="text-sm opacity-80">Subsidy for 2kW</p>
            </div>
            <div>
              <p className="text-4xl font-bold">₹78,000</p>
              <p className="text-sm opacity-80">Subsidy for 3kW to 10kW</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Benefits;
